import { send } from "../../send";

/**
 * send(1.method, 2.url, 3.data, 4.expend) 1.请求类型 2.请求地址 3.请求参数 4.拓展(如统一的uuid)
 * 园区后台企业模块
 */

export const A_Company = {
    // 查询企业列表
    getCompanyList(parmas, expend) {
        return send("GET", "/api/system/company/find", parmas, expend);
    },
    // 添加企业
    postCompanyAdd(parmas, expend) {
        return send("POST", "/api/system/company/create", parmas, expend);
    },
    // 更新企业
    postCompanyEdit(parmas, expend) {
        return send("POST", "/api/system/company/modify", parmas, expend);
    },
    // 删除企业
    postCompanyDel(parmas, expend) {
        return send("POST", "/api/system/company/del", parmas, expend);
    },
    // 获取企业详情
    getCompanyDeils(parmas, expend) {
        return send("GET", "/api/system/company/get", parmas, expend);
    },
    // 首页获取企业
    getCompanyHomeList(parmas, expend) {
        return send("GET", "/api/park/company/list", parmas, expend);
    }
}